import Http from 'common/services/Http';
import { ExportDataItemSearchCriteria } from './models/ExportDataItemSearchCriteria';
import { ExportDataItemOrAdditionalDataSelectedDto } from './models/ExportDataItemSelectedDto';



class ExportDataItemsService {

    public getItems(criteria: ExportDataItemSearchCriteria) {
        return Http.get<ExportDataItemOrAdditionalDataSelectedDto[]>('exportdataitemcompanies/getItems', criteria);
    }   
    
    public update(model: ExportDataItemOrAdditionalDataSelectedDto[]) {
        return Http.put('exportdataitemcompanies', { items : model.map(r => { return { id: r.value, active: r.selected, additionalData: r.additionalData }; }) });
    }

}

export default new ExportDataItemsService();
